/**
 * @file modal
 *
 * Javascript docs : http://usejsdoc.org/
 */

/**
 *
 */
function hideLoader() {
    $('.loader').fadeOut("fast", function () {
        $('.loader').css('display', 'none');
    });
}

/**
 *
 * @type {{bindToProductMedia: Function, displayModal: Function}}
 */
Modal = {
    bindToProductMedia: function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var productMedia = $('.product-media');
        productMedia.on("click", function (e) {
            e.preventDefault();
            $.ajax({
                type: "get",
                url: $(this).data("href")
            })
                .done(Modal.displayModal)
                .fail(function () {
                console.error("Error Retrieving content from" + $(this).data("href"));
            });
        })
    },
    
    bindToRecipeMedia: function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var recipeMedia = $('.fiche-recette .recipe-step-pic .btn');
        recipeMedia.on("click", function (e) {
            e.preventDefault();
            $.ajax({
                type: "get",
                url: $(this).data("href")
            }).done(Modal.displayModal)
                .fail(function () {
                console.error("Error Retrieving content from" + $(this).data("href"));
            });
        })
    },
    
    displayModal: function (dataModal) {
        $('#ModalMedia .modal-body').html(dataModal);
        hideLoader();

        /**
         *
         * @type {string}
         */
        var modalId = "ModalMedia";

        /**
         *
         * @type {string}
         */
        var selectModal = '#' + modalId;
        //afficher la modal
        $(selectModal).show();
        $(selectModal).modal();
        // Ajout fonction sur l'event hide pour supprimer la modal
        $(selectModal).on('hidden.bs.modal', function () {
            $(selectModal).hide();
        });
    }
    
};

$(document).ready(function () {
    Modal.bindToProductMedia();
    Modal.bindToRecipeMedia();
});

